export default __webpack_public_path__ + "static/media/nftArt2.bce1c507.png";